/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_Code_LabelInputs */

const en_signin_code_label = /** @type {(inputs: Signin_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6-digit code`)
};

const id_signin_code_label = /** @type {(inputs: Signin_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kode 6 digit`)
};

/**
* | output |
* | --- |
* | "6-digit code" |
*
* @param {Signin_Code_LabelInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const signin_code_label = /** @type {((inputs?: Signin_Code_LabelInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_Code_LabelInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_signin_code_label(inputs)
	return en_signin_code_label(inputs)
});